module.exports = __webpack_public_path__ + "media/mii-gunner.58082822.wav";